const Events = {
    rpcException: "rpc-exception",                                // Exception
    serverRebooting: "serverRebooting",                           // Exception
    serverBroken: "serverBroken",
    serverActive: "serverActive",                                 // Exception

    // user session related
    sessionBroken: "session-broken",                              // once user is logout

    pushChannelConnected: "push-channel-connected",
    pushChannelDisconnected: "push-channel-disconnected",
    pushChannelFallback: "push-channel-fallback",

    pushChannelFallbackRequested: "push-channel-fallback-requested",

    userSignedIn: "user-signed-in",                                // once user is loggen in (excluding sessionRestore)
    userSignedOut: "user-signed-out",                              // once user is logout
    apiError: "api-error",
    leftNavigation: "left-navigation",
    listCleared: "list-cleared",
    listDeleted: "list-deleted",
    listAdded: "list-added",
    listMultiEdit: "list-multi-edit",

    // Activities related
    onActivitiesStackChange: 'onActivitiesStackChange',  /* Stack<AcitvityModel> */
    requestTopActivityClose: 'requestTopActivityClose',  /* Stack<AcitvityModel> */
    requestActivityToShow: 'requestActivityToShow',      /* { activityClass: class, props: {name:val} } */
    workspaceHide: 'workspaceHide',                      /* Stack<AcitvityModel> */
    workspaceShow: 'workspaceShow',                      /* Stack<AcitvityModel> */

    clickedOnMyAccount: 'clickedOnMyAccount',
    clickedOnStickyNotes: 'clickedOnStickyNotes',
    sizeChanged: 'sizeChanged',                      /* workspace height in px */
    attachmentLoad: 'attachmentLoad',
    permissionsChanged: 'permissionsChanged',                      /* newPermissions */
    roleChanged: 'roleChanged',
    notificationsChanged: "notificationsChanged",
    stickyNotesChanged: "stickyNotesChanged",
    showOrHideStickyNotesList: "showOrHideStickyNotesList",
    organizationLogoChanged: "organizationLogoChanged",
    cancelHidingGridCellEditor: "cancelHidingGridCellEditor",

    trancheChanged: 'trancheChanged',
    orderDetailsChanged: 'orderDetailsChanged',

    rpcStart: "rpc-start",
    rpcEnd: "rpc-end",

    showBuyPlanPopup: "showBuyPlanPopup",
    hideBuyPlanPopup: "hideBuyPlanPopup",
    rpcLimits: "rpc-limits-exceeded",


    treeViewNodeMultiSelect: 'childNodeMultiSelect',
    treeViewNodeSelect: 'nodeSelect',
    treeViewDropOK: 'dropOK',
    treeViewCutOK: 'cutOK',
    treeViewNodeDragEnd: 'nodeDragEnd',
    treeViewContextMenuItemSelected: 'contextMenuItemSelect',
    treeViewNodeDragStart: 'nodeDragStart',
    treeViewOpenNodeContextMenu: 'openNodeContextMenu',

    menuUpdated: "menuUpdated",

    versionAvailable: "versionAvailable",

    showHideLeftMenu: "showHideLeftMenu",

    keepDefaultSorting: "keepDefaultSorting", //The event is called when 'multiselect' or 'pencil' click.

    toggleDelayedTasksList: "toggleDelayedTasksList",
    showDelayedTasksList: "showDelayedTasksList",
    resetSubInfo: "resetSubInfo",
    googleSignIn: "googleSignIn",
    googleSignInError: "googleSignInError",
    azureSignInError: "azureSignInError",
    endpointUpdated: "endpointUpdated",

    unreadMessagesNotifications: "unreadMessagesNotifications"
}

window["Events"] = Events;

export default Events;